<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('stock_out_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/stockout/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('request_stockout')}}</router-link>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('code')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{ $t('no') }}</th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Num')">{{ $t('code') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('OutDateAt')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DocSource')">{{ $t('type') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DocSourceNo')">{{ $t('ref_num') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('BranchName')">{{ $t('branch_name') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('TakerOut')">{{ $t('requestor') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 80px;">
                                <span class="sort-field" @click="onSort('Status')">{{ $t('status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{ name: 'stock_out_preview', params: { id: ret.Id }}">{{ret.Num}}</router-link></td>
                                <td>{{$format(ret.OutDateAt, 'DD-MM-YYYY') }}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td>{{ret.TakerOut}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            query:{
                FromDate: '',
                ToDate: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                SortType: '',
                SortField: ''
            },
            list: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('stockout', this.query).then(res => {
                if(this.$isValid(res)){
                    this.list = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        }
    }
}
</script>
